export default "<p>{{get(field.key, model)}}</p>"